class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.submenu = this.querySelector('.header__submenu, .mega-menu__content');
    
    // Add hover functionality - open immediately on hover
    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    
    // Only close when completely leaving the menu and submenu
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    
    // Add event listeners to the submenu
    if (this.submenu) {
      this.submenu.addEventListener('mouseenter', () => {
        this.isOverSubmenu = true;
      });
      
      this.submenu.addEventListener('mouseleave', () => {
        this.isOverSubmenu = false;
        // Only close if we're not over the main menu
        if (!this.isOverMainMenu) {
          this.close();
        }
      });
    }
    
    this.isOverMainMenu = false;
    this.isOverSubmenu = false;
  }

  onMouseEnter() {
    // Open immediately
    this.isOverMainMenu = true;
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    
    // Rotate caret icon
    const caretIcon = this.mainDetailsToggle.querySelector('summary .icon-caret');
    if (caretIcon) {
      caretIcon.style.transform = 'rotate(180deg)';
    }
  }
  
  onMouseLeave() {
    this.isOverMainMenu = false;
    // Only close if not over submenu
    if (!this.isOverSubmenu) {
      // Small delay to prevent flickering
      setTimeout(() => {
        if (!this.isOverSubmenu && !this.isOverMainMenu) {
          this.close();
          
          // Reset caret icon rotation
          const caretIcon = this.mainDetailsToggle.querySelector('summary .icon-caret');
          if (caretIcon) {
            caretIcon.style.transform = '';
          }
        }
      }, 150); // Longer delay to give more time to move to submenu
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
